/*
 * A bunch of polyfills that we would find useful on all pages.
 * Feel free to add more as long as it adheres to MDN docs.
 */

// A necessary evil. transform-runtime is not able to patch calls to everything because
// javascript is terrible and has no static type checking so transform runtime can never
// know whether a call to e.g. String.startsWith() (which doesn't exist on IE, thanks
// windoze) is actually on a String and not anything else.
// If you remove this, IE crashes on some things, even after they go through transform-runtime
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// URL isn't supported in babel-polyfill (aka core-js) currently
import 'url-polyfill';

// Enable smooth scroll APIs and behaviour for all pages:
// http://iamdustan.com/smoothscroll/
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

// window.location.origin isn't available on IE10
// https://stackoverflow.com/a/25495161/253704
if (!window.location.origin) {
  window.location.origin = `${window.location.protocol}//${
    window.location.hostname
  }${window.location.port ? `:${window.location.port}` : ''}`;
}

// new CustomEvent() isn't available on IE11
// https://stackoverflow.com/a/26596324
(function () {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    const eventParams = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined,
    };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(
      event,
      eventParams.bubbles,
      eventParams.cancelable,
      eventParams.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;

  return null;
})();

// new Event() isn't available on IE11
// https://stackoverflow.com/a/26596324
(function () {
  if (typeof window.Event === 'function') return false;

  function Event(event, params) {
    const eventParams = params || {
      bubbles: false,
      cancelable: false,
    };
    const evt = document.createEvent('Event');
    evt.initEvent(event, eventParams.bubbles, eventParams.cancelable);
    return evt;
  }

  Event.prototype = window.Event.prototype;

  window.Event = Event;

  return null;
})();

// make newlines in contenteditable divs consistent
// https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Editable_content#Differences_in_markup_generation
document.execCommand('defaultParagraphSeparator', false, 'div');
